// extracted by mini-css-extract-plugin
export default {"createdBy":"IssuesTable_createdBy__AlwRh"};